const config = {
  baseDisasterUrl: 'https://disaster-portal.heigit.org',
  orsKey: '5b3ce3597851110001cf624818a886fa34a44e66a25131d50db48822',
  portalDirectionsEndpoint: '/api/v1/routing/avoid_areas/directions',
  portalIsochronesEndPoint: '/api/v1/routing/avoid_areas/isochrones',
  portalCustomHeaderName: 'ors-authorization'
}
export default config
